import { createContext, useContext } from "react";
import type { ProfileTab } from "@/modules/clients/record/profileTabs";

/**
 * Lets tab content switch the record's tab (e.g. Activity → Threads).
 * Page mode keeps the tab in ?tab=; panel mode in local state.
 */
export const RecordTabNavContext = createContext<{
  mode: "page" | "panel";
  openTab: (tab: ProfileTab) => void;
} | null>(null);

export const useRecordTabNav = () => useContext(RecordTabNavContext);
